var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / VE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-VE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-4",
    fill: "#063191",
    mask: "url(#mask-2)",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E2213B",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10.6666667 C10.3681898,10.6666667 10.6666667,10.9651435 10.6666667,11.3333333 C10.6666667,11.7015232 10.3681898,12 10,12 C9.63181017,12 9.33333333,11.7015232 9.33333333,11.3333333 C9.33333333,10.9651435 9.63181017,10.6666667 10,10.6666667 Z M18,10.6666667 C18.3681898,10.6666667 18.6666667,10.9651435 18.6666667,11.3333333 C18.6666667,11.7015232 18.3681898,12 18,12 C17.6318102,12 17.3333333,11.7015232 17.3333333,11.3333333 C17.3333333,10.9651435 17.6318102,10.6666667 18,10.6666667 Z M11.3333333,8.66666667 C11.7015232,8.66666667 12,8.9651435 12,9.33333333 C12,9.70152317 11.7015232,10 11.3333333,10 C10.9651435,10 10.6666667,9.70152317 10.6666667,9.33333333 C10.6666667,8.9651435 10.9651435,8.66666667 11.3333333,8.66666667 Z M16.6666667,8.66666667 C17.0348565,8.66666667 17.3333333,8.9651435 17.3333333,9.33333333 C17.3333333,9.70152317 17.0348565,10 16.6666667,10 C16.2984768,10 16,9.70152317 16,9.33333333 C16,8.9651435 16.2984768,8.66666667 16.6666667,8.66666667 Z M14,8 C14.3681898,8 14.6666667,8.29847683 14.6666667,8.66666667 C14.6666667,9.0348565 14.3681898,9.33333333 14,9.33333333 C13.6318102,9.33333333 13.3333333,9.0348565 13.3333333,8.66666667 C13.3333333,8.29847683 13.6318102,8 14,8 Z",
    id: "Oval-61",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFD044",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/VE.0eb2974445c6c3b534088318513dad5b.svg";
export { ForwardRef as ReactComponent };